
<script>
import { compareAsc, parseISO } from 'date-fns';
import { uniq, cloneDeep } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import CardsListItemLignePanier from './cards-list-item-ligne-panier';
import FilArianne from './fil-arianne';

export default {
  name: 'ValidPanier',
  components: {
    CardsListItemLignePanier,
    FilArianne
  },
  data: () => ({
    lignesLoaded: 0,
    loading: false
  }),
  computed: {
    ...mapGetters({
      _lignesCmd: 'cart/cart',
      tiers: 'user/tiers',
      commentairesPanier: 'cart/commentairesPanier',
      user: 'user/user'
    }),
    lignesCmd () {
      return cloneDeep(this._lignesCmd).sort((a, b) => {
        let c = ('' + a.numAdresse).localeCompare('' + b.numAdresse);
        if (c !== 0) {
          return c;
        }
        c = compareAsc(parseISO(a.datePrevueLivraison), parseISO(b.datePrevueLivraison));
        if (c !== 0) {
          return c;
        }

        try {
          return a.idLigne.localeCompare(b.idLigne);
        } catch (e) { }
        return 0;
      });
    },
    cumulPetitCamion () {
      const cumulPetit = this.lignesCmd
        .filter(ligne => ligne.codeModeCamion === 'VISP' || ligne.codeModeCamion === 'PNEUP')
        .reduce((total, ligne) => total + ligne.quantiteCommande, 0);

      if (cumulPetit > 17) {
        return 'Attention, le poids total livré en petit camion représente ' + cumulPetit + ' t, soit plus d’un petit camion (17 t)';
      } else { return ''; }
    },
    cumulSoufflerie () {
      const cumulQte = this.lignesCmd
        .filter(ligne => ligne.codeModeCamion === 'VIS' || ligne.codeModeCamion === 'PNEU')
        .reduce((total, ligne) => total + ligne.quantiteCommande, 0);

      if (cumulQte > 27) {
        return 'Attention, le poids total livré en camion aliment représente ' + cumulQte + ' t, soit plus que la capacité d’un camion (27 t).';
      } else { return ''; }
    },
    cumulQteCmde () {
      const cumulTotal = this.lignesCmd
        .reduce((total, ligne) => total + ligne.quantiteCommande, 0);
      return cumulTotal;
    },
    commandeValide () {
      return true; // todo
    },
    loaded () {
      return this.lignesLoaded === this.lignesCmd.length;
    },
    commantaireEntete () {
      return Object.entries(this.commentairesPanier)
        .sort((a, b) => {
          return a[0] === 'libre' ? 1 : (b[0] === 'libre' ? -1 : 0);
        }).map(([key, value]) => {
          if (key === 'libre') {
            return value;
          } else if (value === true) {
            return key;
          }
        }).filter(c => !!c)
        .join(', ');
    },
    canWriteCmd () {
      return this.hasRole('COM_ALI_ECRITURE_TOUS') ||
        this.hasRole('COM_ALI_ECRITURE_REGION') ||
        this.hasRole('COM_ALI_ECRITURE_PORTEFEUILLE') ||
        this.hasRole('COM_ALI_ECRITURE_PERSONNELLE');
    }
  },
  methods: {
    ...mapActions({
      clearCart: 'cart/reset',
      envoyerCommande: 'commandes/envoyerCommande',
      updateLine: 'cart/updateLine'
    }),

    ajouterCommentaireLigne (ligne, commentaire) {
      if (!ligne.commentaire) {
        ligne.commentaire = '';
      } else {
        ligne.commentaire += '; ';
      }
      ligne.commentaire += commentaire;
    },
    validerPanier () {
      this.loading = true;
      const commande = {
        commentaire: this.commantaireEntete,
        lignes: this.lignesCmd
      };

      for (const ligne of commande.lignes) {
        if (ligne.melangeDechargement) {
          this.ajouterCommentaireLigne(ligne, 'MELANGER AU DECHARGEMENT');
        }

        for (const key of [1, 2, 3]) {
          if (typeof ligne['codeTypeSilo' + key] === 'string' && ligne['codeTypeSilo' + key].startsWith('997:')) {
            this.ajouterCommentaireLigne(ligne, ligne['codeTypeSilo' + key].replace('997:', ''));
            ligne['codeTypeSilo' + key] = 997;
          }
        }
      }

      const param = {
        numTiers: this.tiers.numTiers,
        commande
      };

      this.envoyerCommande(param).then(
        confirmation => {
          this.$ga.event({
            eventCategory: 'order',
            eventAction: 'sent',
            eventLabel: confirmation.numero
          });
          this.clearCart();

          setTimeout(() => {
            this.$router.push({ name: 'main.catalog.cart.confirm', query: confirmation });
          }, 50);
        },
        erreur => {
          if (erreur.response.status === 409) {
            // const text = 'CODE_ERREUR:[M,456456,libelleArticle]:message erreur;...';
            const text = erreur.response.data.message;
            const matches = text.matchAll(/(\w+):\[(\w),(\d+),(.+?)\]:(.+?)(?:;|$)/gi);
            let erreurTexte = '<b>Veuillez corriger votre panier</b><ul>';
            const erreurLines = [];
            for (const match of matches) {
              erreurLines.push('<li><b>Article : ' + match[4] + '</b> : ' + match[5] + '</li>');
            }
            // delete duplicates
            erreurTexte += uniq(erreurLines).join('');
            erreurTexte += '</ul>';
            this.$dialog.warning({
              text: erreurTexte + '<br/>',
              title: 'Commande invalide',
              width: '900px',
              actions: {
                panier: { text: 'Corriger mon panier', color: 'warning', flat: false }
              }
            })
              .then(
                result => {
                  this.$router.push({ name: 'main.catalog.cart' });
                }
              );
          } else {
            throw erreur;
          }
        }
      ).finally(() => {
        this.loading = false;
      });
    },
    cancel () {
      this.$router.back();
    },
    ligneLoaded () {
      this.lignesLoaded += 1;
    },
    hasSameDateFin (lignes) {
      return uniq(lignes.map(l => l.finDatePrevueLivraison)).length === 1;
    },
    hasRole (role) {
      return ~this.user.roles.indexOf(role);
    },
    changeReglement (oldLine, { codeReglement, numDomiciliationBancaire }) {
      const newLine = cloneDeep(oldLine);
      newLine.numDomiciliationBancaire = numDomiciliationBancaire;
      newLine.codeReglement = codeReglement;

      this.updateLine({ oldLine, newLine });
    },
    cloneReglement (ligne) {
      let cloneOk = true;
      for (const key in this.$refs) {
        if (key.startsWith('ligne_')) {
          const result = this.$refs[key].applyModeReglementIfPossible(ligne.codeReglement, ligne.numDomiciliationBancaire);
          cloneOk = cloneOk && result;
        }
      }

      if (!cloneOk) {
        this.$dialog.warning({
          title: 'Atttention',
          text: 'Le mode de règlement n\'a pas pu être dupliqué sur toutes les lignes de votre commande.',
          actions: {
            true: {
              text: 'Fermer',
              flat: false,
              outlined: true
            }
          }
        });
      }
    }
  }
};
</script>

<template>
  <div>
    <Loader v-if="loading" />
    <FilArianne :step="2" />
    <h2>
      Validation règlement
      <CardsHelp
        :page="'VALID-COMMANDE'"
        :niveau="'TITRE'"
      />
    </h2>

    <CardsList
      :items="lignesCmd"
      column-size="100%"
      :group-by="ligne=>({numAdresse:ligne.numAdresse, dateDebut:ligne.datePrevueLivraison})"
    >
      <template v-slot:groupTitle="{group, items}">
        <div class="secondary--text">
          <RefValue
            :code="group.numAdresse"
            type="ADRESSE"
          /><br>
          <span v-if="hasSameDateFin(items)">
            Livraison du {{ group.dateDebut | date }} au {{ items[0].finDatePrevueLivraison | date }}
          </span>
          <span v-else>
            Livraison à partir du {{ group.dateDebut | date }}
          </span>
        </div>
      </template>
      <template v-slot:item="{item}">
        <CardsListItemLignePanier
          :ref="'ligne_'+item.idLigne"
          :ligne="item"
          @loaded="ligneLoaded()"
          @changeReglement="changeReglement(item, $event)"
          @cloneReglement="cloneReglement(item)"
        />
      </template>
    </CardsList>

    <div class="poids">
      <div class="lib-cumul no-wrap primary--text">
        Poids total
      </div>
      <div class="cumul no-wrap primary--text">
        {{ cumulQteCmde | formatDecimal(3) }} t
      </div>
    </div>

    <div class="display-inline-block warning--text">
      {{ cumulSoufflerie }}
    </div>
    <div class="display-inline-block warning--text">
      {{ cumulPetitCamion }}
    </div>

    <div class="actions-panier">
      <v-btn
        outlined
        color="grey"
        :block="isMobile"
        @click="cancel()"
      >
        Retour panier
      </v-btn>
      <v-btn
        :block="isMobile"
        :disabled="!canWriteCmd || !loaded || !(lignesCmd && lignesCmd.length && commandeValide) "
        @click="validerPanier()"
      >
        Confirmer la commande
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.poids {
  margin-top: 10px;
  display: flex;
  flex-direction: row;

  .lib-cumul {
    flex: 2;
  }

  .cumul {
    flex: 1;
    text-align: right;
    font-size: 20px;
  }
}

.actions-panier {
  margin-top: 2em;
  text-align: center;
  .v-btn {
    display: inline-block;
    margin: 0 1em;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .actions-panier {
    display: flex;
    flex-wrap: wrap-reverse;
    .v-btn {
      width: 100%;
      margin: 0;
      margin-top: 1em;
    }
  }
}
</style>
